import axios from '../../../config/axios';

const API_BASE_URL = `${process.env.REACT_APP_GATEWAY_BASE_URL}/product-final`;

export interface Product {
  id: number;
  name: string;
  norm?: string;
  quantity?: number;
  scripts: Script[];
  createdAt?: string;
  updatedAt?: string;
}

export interface Script {
  id: number;
  name: string;
  productId?: number;
  items?: ScriptItem[];
  createdAt?: string;
  updatedAt?: string;
  cost?: number;
  additionalDeadline?: number;
  totalDeliveryTime?: number;
  materials?: any[];
}

export interface Price {
  id?: number | string;
  price: string;
  unitOfMeasurement?: {
    id: number;
    name: string;
  };
}

export interface ScriptItem {
  id: number | string;
  type: string;
  order: number;
  rawMaterialId?: number;
  rawMaterialName?: string;
  serviceId?: number;
  serviceName?: string;
  productFinalId?: number;
  productFinalName?: string;
  resourceId?: number;
  resourceName?: string;
  unitOfMeasurementId?: number;
  productScript?: { id: number; name: string } | null;
  executionTime?: number | null;
  setupTime?: number | null;
  requiredQualification?: string;
  deliveryTime?: string | number;
  deadlineInDays?: number;
  weight?: number;
  idealMeasurements?: string;
  density?: number;
  pricePerUnit?: number;
  prices?: Price[];
  quantity?: number;
  category?: string;
  resourceType?: string;
  description?: string | null;
  observation?: string | null;
  companyId?: number;
  machineCode?: string;
  machineName?: string;
  machineCostPerHour?: number;
  machineCapacity?: string;
  companyName?: string;
  companyCnpj?: string;
  company?: { id: number; name: string; cnpj?: string } | null;
  rawMaterial?: { id: number; name: string } | null;
  service?: { id: number; name: string } | null;
  resource?: { id: number; name: string } | null;
  productFinal?: { id: number; name: string } | null;
  productScriptName?: string;
  productScriptItems?: any[];
  cost?: number;
}

export const fetchProductById = async (productId: string): Promise<Product> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/product/${productId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar produto:', error);
    throw error;
  }
};

export const fetchScriptsByProductId = async (productId: number, limit: number = 10, offset: number = 0, search?: string) => {
  try {
    const page = Math.floor(offset / limit) + 1;
    const response = await axios.get(`${API_BASE_URL}/script`, {
      params: { page, limit, search, productId }
    });
    return response.data.data;
  } catch (error) {
    console.error('Erro ao buscar scripts por produto:', error);
    return [];
  }
};